import React from "react";

export default function RowHeader() {
    return (
        <tr>
            <th>زمان</th>
            <th>تاریخ</th>
            <th>مقصد</th>
            <th>کد سرویس</th>
            <th>پرداخت کننده</th>
            <th>نوع </th>
            <th>مبلغ</th>
            <th>کد قاصد</th>

            <th>عودتی</th>
            <th>ترک بزرگ</th>
            <th>بیمه</th>
            <th>صندوق</th>
            <th>بارحجیم</th>
            <th>بازگشت</th>
        </tr>


    )
}